var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffiReason4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2738_1481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1248 0.666992C23.952 0.682326 15.5877 0.973659 10.2785 6.27899C4.97317 11.592 4.68184 19.9525 4.6665 36.1253H23.5035C22.1251 34.405 21.1352 32.4069 20.6017 30.268C18.5432 22.0187 26.0182 14.5437 34.2675 16.6022C36.4602 17.1503 38.4458 18.1585 40.1248 19.504V0.666992ZM4.6665 41.8753C4.68184 58.0443 4.97317 66.4087 10.2785 71.7178C15.5915 77.027 23.952 77.3145 40.1248 77.3337V47.1385C38.6128 50.1648 36.2876 52.71 33.41 54.4887C30.5324 56.2674 27.2161 57.2093 23.8332 57.2087C23.0707 57.2087 22.3394 56.9058 21.8002 56.3666C21.2611 55.8274 20.9582 55.0962 20.9582 54.3337C20.9582 53.5712 21.2611 52.8399 21.8002 52.3007C22.3394 51.7616 23.0707 51.4587 23.8332 51.4587C26.6377 51.4586 29.3603 50.5125 31.5605 48.7735C33.7608 47.0344 35.3101 44.604 35.958 41.8753H4.6665ZM45.8748 77.3337C62.0438 77.3145 70.4082 77.027 75.7173 71.7178C81.0265 66.4125 81.314 58.0443 81.3332 41.8753H50.0417C50.6895 44.604 52.2389 47.0344 54.4391 48.7735C56.6394 50.5125 59.362 51.4586 62.1665 51.4587C62.929 51.4587 63.6603 51.7616 64.1994 52.3007C64.7386 52.8399 65.0415 53.5712 65.0415 54.3337C65.0415 55.0962 64.7386 55.8274 64.1994 56.3666C63.6603 56.9058 62.929 57.2087 62.1665 57.2087C58.7835 57.2093 55.4673 56.2674 52.5897 54.4887C49.712 52.71 47.3868 50.1648 45.8748 47.1385V77.3337ZM81.3332 36.1253C81.314 19.9525 81.0265 11.5882 75.7173 6.27899C70.412 0.973659 62.0438 0.682326 45.8748 0.666992V19.504C47.5941 18.1262 49.5909 17.1363 51.7283 16.6022C59.9815 14.5398 67.4603 22.0148 65.3942 30.268C64.8618 32.4065 63.8732 34.4047 62.4962 36.1253H81.3332Z",
    fill: "url(#paint0_linear_2738_1481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8724 22.1838C34.9435 22.701 36.7822 23.8957 38.0964 25.5779C39.4105 27.2602 40.1246 29.3334 40.1251 31.4681V36.1256H35.4676C33.3329 36.1251 31.2596 35.411 29.5774 34.0969C27.8951 32.7828 26.7004 30.944 26.1832 28.8729C25.9534 27.949 25.9665 26.9813 26.2212 26.0639C26.4759 25.1465 26.9636 24.3106 27.6368 23.6373C28.31 22.9641 29.146 22.4764 30.0634 22.2217C30.9808 21.967 31.9484 21.954 32.8724 22.1838ZM45.8751 31.4681V36.1256H50.5326C54.9217 36.1256 58.7512 33.1356 59.8169 28.8729C60.047 27.9486 60.034 26.9804 59.7791 26.0626C59.5243 25.1448 59.0362 24.3085 58.3625 23.6352C57.6887 22.9618 56.8522 22.4743 55.9342 22.2199C55.0163 21.9656 54.0481 21.9531 53.1239 22.1838C51.0535 22.7017 49.2156 23.8967 47.9023 25.5789C46.5889 27.2611 45.8754 29.3339 45.8751 31.4681Z",
    fill: "url(#paint1_linear_2738_1481)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2738_1481",
    x: 0.666504,
    y: 0.666992,
    width: 84.6665,
    height: 84.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2738_1481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2738_1481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2738_1481",
    x1: 42.9998,
    y1: 0.666992,
    x2: 42.9998,
    y2: 77.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709587,
    stopColor: "#041539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2738_1481",
    x1: 43.0002,
    y1: 22.0195,
    x2: 43.0002,
    y2: 36.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709587,
    stopColor: "#041539"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiReason4);
export default __webpack_public_path__ + "static/media/affiReason4.cf32f168000a6f5d1702a08f8cd9361e.svg";
export { ForwardRef as ReactComponent };